import { useCallback, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

import { theme } from "../../../theme";
import { commonSwal } from "../../../components/swalAlert/swalAlert";
import { approvalProcessStep, updateFtmApproveAndReject } from "../service";
import { Context } from "../Provider";
import useCustomNavigate from "../../../components/hooks/useCustomNavigate";
import EditFtm from "../../components/editFtm";

const MarkAsApproved = ({ approvalProcessKey, isShowFtmEdit = false }) => {
    const { navigateToCustom } = useCustomNavigate();
    const { dispatch } = useContext(Context);
    const { ftm_id } = useParams();

    const [openEditFtm, setOpenEditFtm] = useState(false);

    const handleOpenEditFtm = () => setOpenEditFtm(true);
    const handleCloseEditFtm = () => setOpenEditFtm(false);

    // Step approval handler
    const handleStepApproved = useCallback(() => {
        commonSwal({
            notificationType: "APPROVE_FTM_APPROVAL_PROCESSES",
            preConfirm: async () => approvalProcessStep(ftm_id, approvalProcessKey),
            isConfirmed: (result) => {
                if (result?.isConfirmed && result?.value?.status === "Success") {
                    dispatch({ type: "INCREMENT_REFRESH_COUNT" });
                    toast.success(result?.value?.message);
                }
            },
        });
    }, [approvalProcessKey, dispatch, ftm_id]);

    // Full approve/reject handler
    const handleFtmApproveAndReject = useCallback(
        (isApprove) => {
            const isApproval = isApprove === 1;
            commonSwal({
                notificationType: isApproval ? "APPROVE_FTM" : "REJECT_FTM",
                preConfirm: async (reason = "") => {
                    if (!isApproval && reason === "") {
                        Swal.showValidationMessage("Reason required");
                        return;
                    }
                    return updateFtmApproveAndReject(ftm_id, isApprove, reason);
                },
                isConfirmed: (result) => {
                    if (result?.isConfirmed && result?.value?.status === "Success") {
                        dispatch({ type: "INCREMENT_REFRESH_COUNT" });
                        navigateToCustom(`/ftm/view/${ftm_id}`)
                    }
                },
            });
        },
        [dispatch, ftm_id, navigateToCustom]
    );

    const isApproveKey = approvalProcessKey === "IS_APPROVE";

    return (
        <div className="card-footer d-flex justify-content-end align-items-center py-0 mt-2">
            {isShowFtmEdit && (
                <>
                    <button
                        type="button"
                        className="btn btn-icon btn-3 btn-dark btn-sm me-2"
                        onClick={handleOpenEditFtm}
                    >
                        <span className="btn-inner--icon">
                            <i className="material-icons text-lg me-2">edit</i>
                        </span>
                        Edit Tradesperson
                    </button>

                    <EditFtm
                        ftm_id={ftm_id}
                        open={openEditFtm}
                        handleClose={handleCloseEditFtm}
                        handleSubmitClose={() => dispatch({ type: "INCREMENT_REFRESH_COUNT" })}
                        isApproveProcess={true}
                    />
                </>
            )}

            <button
                type="button"
                className={`btn bg-gradient-${theme.main} btn-sm`}
                onClick={() =>
                    isApproveKey ? handleFtmApproveAndReject(1) : handleStepApproved()
                }
            >
                {isApproveKey && (
                    <span className="btn-inner--icon">
                        <i className="material-icons text-lg me-2">thumb_up</i>
                    </span>
                )}
                {isApproveKey ? "Approve Tradesperson" : "Mark as Approve"}
            </button>

            {isApproveKey && (
                <button
                    type="button"
                    className="btn btn-icon btn-3 btn-danger btn-sm ms-2"
                    onClick={() => handleFtmApproveAndReject(-1)}
                >
                    <span className="btn-inner--icon">
                        <i className="material-icons text-lg me-2">thumb_down</i>
                    </span>
                    Reject Tradesperson
                </button>
            )}
        </div>
    );
};

export default MarkAsApproved;